import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Modal, Button } from "reactstrap"
import ReactLoading from 'react-loading';
import styled from "styled-components";
import classNames from 'classnames';
import { useHistory } from 'react-router';

import InfoYellow from "../../images/danger-sign-yellow.png";
import InfoRed from "../../images/danger-sign-red.png";
import InfoGreen from "../../images/info-kredit.png";
import CircleCloseButton from "../../images/round-close-button.png";

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const ModalConfirmationSale = ({
  yesAction,
  cancelAction,
  isOpen,
  headerText,
  bodyText,
  disabled,
  isLoading,
  modalType,
  freeCancel = 0,
  email = '',
  seller_points,
  penaltyAmount
}) => {
  const history = useHistory()
  return (
    <Modal
      modalClassName="confirmation-modal-sale"
      contentClassName={`custom-main-content`}
      isOpen={isOpen}
      toggle={cancelAction}
    >
      <div className='modal-confirmation'>
        <KickImage onClick={cancelAction} src={CircleCloseButton} alt="..." className="close-icon" />
        {
          modalType === 'decline' ? (
            <>
              <p className='header'>Are you sure you want to decline the sale?</p>
              {
                parseInt(seller_points) === 5 ?
                  <p className='description' >
                    {
                      freeCancel > 0 ?
                        `Your seller point will be deducted by 1 point but you will not be charged with IDR 50.000 cancellation fee because you have ${parseInt(freeCancel)} free cancellation pass.`
                        :
                        `Your seller points will be deducted by 1 point and you will be penalized with ${penaltyAmount} taken from your Seller Credit’s balance.`
                    }
                  </p>
                  : freeCancel > 0 ?
                    <p className='description' >
                      Your seller point will be deducted by 1 point but you will not be charged with IDR 50.000 cancellation fee because you have {parseInt(freeCancel)} free cancellation pass.
                    </p>
                    :
                    <p className='description'>Your seller points will be deducted by 1 point and you will be
                      penalized with {penaltyAmount} taken from your Seller Credit’s balance.</p>
              }
              <div className={`info-wrapper ${parseInt(seller_points) === 5 ? "almost-suspend" : freeCancel > 0 ? "free-cancel" : ""} `}>
                <div className='left'>
                  {
                    parseInt(seller_points) === 5 ?
                      <KickImage src={InfoRed} alt="..." className="info-icon" />
                      :
                      freeCancel > 0 ?
                        <KickImage src={InfoGreen} alt="..." className="info-icon" />
                        :
                        <KickImage src={InfoYellow} alt="..." className="info-icon" />
                  }
                  <p className='point-desc'>Points after rejection:</p>
                </div>
                <p className='point'>{(parseFloat(seller_points) - 1)?.toFixed(1)}</p>
              </div>
              <div className='button-wrapper'>
                <Button className="reject-btn" disabled={disabled || isLoading} onClick={yesAction}>
                  {
                    isLoading ?
                      <LoadingWrapper>
                        <ReactLoading
                          type={'spin'}
                          height={20}
                          width={20}
                          color={"#000"}
                        />
                      </LoadingWrapper>
                      :
                      "Reject"
                  }
                </Button>
                <Button className="cancel-btn" disabled={disabled || isLoading} onClick={cancelAction}>Cancel</Button>
              </div>
            </>
          ) : (
            <>
              <p className='header'>Are you sure you want to confirm the sale?</p>
              <p className='description'>
                Please deliver the goods ASAP and input the AWB on your Seller Dashboard. Please ensure you’ve read the instructions we’ve sent to your email {email}.
              </p>

              <div className='button-wrapper'>
                <Button className="cancel-btn" disabled={disabled || isLoading} onClick={cancelAction}>Cancel</Button>
                <Button className="confirm-btn" disabled={disabled || isLoading} onClick={yesAction}>
                  {
                    isLoading ?
                      <LoadingWrapper>
                        <ReactLoading
                          type={'spin'}
                          height={20}
                          width={20}
                          color={"#000"}
                        />
                      </LoadingWrapper>
                      :
                      "Confirm"
                  }
                </Button>
              </div>
            </>
          )
        }
        {modalType === 'decline' ? <p onClick={() => history.push("/helps/general-faq")} className='link'>How do i calculate the cancellation fee?</p> : null}
      </div>
    </Modal >
  )
}

export default ModalConfirmationSale;